import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProjectPaymentActions from './project-payment.actions';
import { ProjectPaymentService } from '../../services/project-payment.service';
import { Router } from '@angular/router';

@Injectable()
export class ProjectPaymentEffects {
  loadProjectPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectPaymentActions.loadProjectPayment),
      exhaustMap((_) =>
        this.projectPaymentService.getProjectPayment().pipe(
          map((data) =>
            ProjectPaymentActions.loadProjectPaymentSuccess({
              projectPayment: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProjectPaymentActions.loadProjectPaymentFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProjectPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectPaymentActions.addProjectPayment),
      concatMap(({ newProjectPayment }) =>
        this.projectPaymentService.createProjectPayment(newProjectPayment).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return ProjectPaymentActions.addProjectPaymentSuccess({
              newProjectPayment: data,
            });
          }),
          catchError((error) => {
            console.log('error ', error);

            return of(
              ProjectPaymentActions.addProjectPaymentFailure({
                error: error.error.message,
              })
            );
          })
        )
      )
    )
  );

  // addSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ProjectPaymentActions.addProjectPaymentSuccess),
  // 			tap(() => {
  // 				return this.router.navigate([ '/project' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  updateProjectPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectPaymentActions.updateProjectPayment),
      concatMap(({ updateProjectPayment }) =>
        this.projectPaymentService
          .updateProjectPayment(updateProjectPayment)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ProjectPaymentActions.updateProjectPaymentSuccess({
                updateProjectPayment: data,
              });
            }),
            catchError((error) => {
              return of(
                ProjectPaymentActions.updateProjectPaymentFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectPaymentActions.updateProjectPaymentSuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeProjectPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectPaymentActions.removeProjectPayment),
      map((action) => action.ids),
      concatMap((ids) =>
        this.projectPaymentService.deleteProjectPayment(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProjectPaymentActions.removeProjectPaymentSuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProjectPaymentActions.updateProjectPaymentFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectPaymentService: ProjectPaymentService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
